import { Configure, Index } from "react-instantsearch";
import { VirtualSearchBox } from "../search-shared/VirtualSearchBox";
import { searchIndexes } from "../search-shared/client";
import { useAutoComplete } from "../hooks/useAutoComplete";

interface AutoCompleteProviderProps {
  query: string;
  children: (suggestion: string) => React.ReactNode;
}

export function AutoCompleteProvider({ query, children }: AutoCompleteProviderProps) {
  return (
    <Index indexName={searchIndexes.SUGGESTIONS}>
      <VirtualSearchBox />
      <Configure
        hitsPerPage={1}
        query={query || ""}
      />
      <AutoCompleteInner query={query}>
        {children}
      </AutoCompleteInner>
    </Index>
  );
}

function AutoCompleteInner({ query, children }: AutoCompleteProviderProps) {
  const suggestion = useAutoComplete();
  
  // Only show suggestion if user has typed something and suggestion starts with their input
  const shouldShowSuggestion = query && 
    suggestion && 
    suggestion.toLowerCase().startsWith(query.toLowerCase()) &&
    suggestion.toLowerCase() !== query.toLowerCase();

  return <>{children(shouldShowSuggestion ? suggestion : "")}</>;
}
